import { MixinClassEffect } from '../utils';
import { applyChanges } from '../utils/changes';
export var FileInputSize;
(function (FileInputSize) {
    FileInputSize["small"] = "small";
    FileInputSize["medium"] = "medium";
    FileInputSize["large"] = "large";
})(FileInputSize || (FileInputSize = {}));
export class FileInputState {
    constructor(setState) {
        this.state = Object.assign({}, FileInputState.initialState);
        this.props = {};
        this.onDragEnter = (e) => {
            var _a;
            const target = e.target;
            const targetThis = !!(target && ((_a = this.$rootElement) === null || _a === void 0 ? void 0 : _a.contains(target)));
            if (targetThis) {
                e.preventDefault();
            }
            this.setState({
                dropzoneActive: true,
                dropzoneHovered: targetThis
            });
        };
        this.onDragLeave = (e) => {
            var _a;
            const target = e.target;
            const targetThis = !!(target && ((_a = this.$rootElement) === null || _a === void 0 ? void 0 : _a.contains(target)));
            this.setState({
                dropzoneActive: !!e.relatedTarget,
                dropzoneHovered: targetThis
            });
        };
        this.onDragEnd = () => {
            this.setState({
                dropzoneActive: false,
                dropzoneHovered: false
            });
        };
        this.onDrop = (e) => {
            var _a, _b, _c;
            e.preventDefault();
            const files = ((_a = e === null || e === void 0 ? void 0 : e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) || null;
            this.setState({
                dropzoneActive: false,
                dropzoneHovered: false,
                files
            });
            if (this.$inputElement) {
                this.$inputElement.files = files;
            }
            (_c = (_b = this.props).onFileSelect) === null || _c === void 0 ? void 0 : _c.call(_b, files);
        };
        this.onDragover = (e) => {
            // Для того, чтобы drop срабатывал
            e.preventDefault();
        };
        this.onInputChange = (e) => {
            var _a, _b;
            const target = e.target;
            const files = target.files || null;
            this.setState({
                files
            });
            (_b = (_a = this.props).onFileSelect) === null || _b === void 0 ? void 0 : _b.call(_a, files);
        };
        this.clearInput = (triggerCallback = true) => {
            var _a, _b;
            if (this.$inputElement) {
                this.$inputElement.value = '';
                this.setState({
                    files: null
                });
                if (triggerCallback) {
                    (_b = (_a = this.props).onFileSelect) === null || _b === void 0 ? void 0 : _b.call(_a, null);
                }
            }
        };
        this.rootListenersEffect = new MixinClassEffect((rootRef) => {
            if (rootRef) {
                rootRef.addEventListener('dragover', this.onDragover);
                rootRef.addEventListener('drop', this.onDrop);
            }
            return () => {
                if (!rootRef)
                    return;
                rootRef.removeEventListener('dragover', this.onDragover);
                rootRef.removeEventListener('drop', this.onDrop);
            };
        });
        this.inputListenersEffect = new MixinClassEffect((inputRef) => {
            if (inputRef) {
                inputRef.addEventListener('change', this.onInputChange);
            }
            return () => {
                if (!inputRef)
                    return;
                inputRef.removeEventListener('change', this.onInputChange);
            };
        });
        this.setState = (changes) => {
            const isStateChanged = Object.entries(changes).some(([key, value]) => this.state[key] !== value);
            if (isStateChanged) {
                setState((prevState) => (Object.assign(Object.assign({}, prevState), changes)));
            }
        };
    }
    onDidMount() {
        this.attachDocumentEventListeners();
    }
    onWillUnmount() {
        this.detachDocumentEventListeners();
    }
    update(state, props, $rootElement, $inputElement) {
        applyChanges(this.state, state);
        applyChanges(this.props, props);
        if (this.$rootElement !== $rootElement) {
            this.$rootElement = $rootElement || undefined;
            this.rootListenersEffect.update(this.$rootElement);
        }
        if (this.$inputElement !== $inputElement) {
            this.$inputElement = $inputElement || undefined;
            this.inputListenersEffect.update(this.$inputElement);
        }
    }
    attachDocumentEventListeners() {
        if (typeof document !== 'undefined') {
            document.addEventListener('dragenter', this.onDragEnter);
            document.addEventListener('dragleave', this.onDragLeave);
            document.addEventListener('dragend', this.onDragEnd);
        }
    }
    detachDocumentEventListeners() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('dragenter', this.onDragEnter);
            document.removeEventListener('dragleave', this.onDragLeave);
            document.removeEventListener('dragend', this.onDragEnd);
        }
    }
}
FileInputState.initialState = {
    dropzoneActive: false,
    dropzoneHovered: false
};

//# sourceMappingURL=FileInput.js.map
